import React, { memo } from 'react';

import HtmlContentFromApi from '@r1-frontend/ui-react/components/HtmlContentFromApi';

import { IImageProps, ImageElement } from './components/ImageElement';
import { ICounterProps, IncrementDecrementCounter } from './components/IncrementDecrementCounter';
import { IKebabItem, IKebabMenuProps, KebabMenuElement } from './components/KebabMenuElement';
import { IPriceProps, PriceElement } from './components/PriceElement';

import * as ST from './styled';

export type { IKebabItem };

export interface TariffElementWithCountProps {
    title: string,
    titleText?: string,
    imageProps: IImageProps,
    kebabMenuProps?: IKebabMenuProps,
    priceProps?: IPriceProps,
    counterProps?: ICounterProps,
}

/**
 * Элемент тарифа со счетчиком
 * @param priceProps - свойсвта цены
 * @param counterProps - свойства счетчика
 * @param kebabMenuProps - свойства кебаб-меню
 */
export const TariffElementWithCount = (item: TariffElementWithCountProps): JSX.Element => {
    const {
        title,
        titleText,
        kebabMenuProps,
        imageProps,
        priceProps,
        counterProps,
    } = item;
    return (
        <ST.TariffElement>
            <ST.RowWrap>
                <ST.DescriptionWrap>
                    <ImageElement
                        {...imageProps}
                    />

                    <ST.TitleWrap>
                        <ST.Title>{title}</ST.Title>

                        {titleText &&
                            <ST.DesktopOnlyWrap data-test='desktop-wrap'>
                                <ST.Description>
                                    <HtmlContentFromApi>
                                        {titleText}
                                    </HtmlContentFromApi>
                                </ST.Description>
                            </ST.DesktopOnlyWrap>
                        }
                    </ST.TitleWrap>
                </ST.DescriptionWrap>

                <ST.DesktopOnlyWrap data-test='desktop-wrap' withCounts={true}>
                    <IncrementDecrementCounter
                        {...counterProps}
                        data-test='counter'
                    />
                    <PriceElement
                        {...priceProps}
                    />
                </ST.DesktopOnlyWrap>

                <KebabMenuElement
                    {...kebabMenuProps}
                />
            </ST.RowWrap>

            <ST.MobileOnlyWrap data-test='mobile-wrap'>
                {titleText &&
                    <ST.Description>
                        <HtmlContentFromApi>
                            {titleText}
                        </HtmlContentFromApi>
                    </ST.Description>
                }
                <PriceElement
                    {...priceProps}
                />
                <IncrementDecrementCounter
                    {...counterProps}
                />
            </ST.MobileOnlyWrap>
        </ST.TariffElement>
    );
};

export default memo(TariffElementWithCount);
